<template>
    <div
        v-if="config.TOWER_ADDRESS_POPUP"
        :class="homePage ? 'tower-address-wrapper home-tower-address' : 'tower-address-wrapper'">
        <div 
            v-if="mainTowerAddress" 
            class="main-tower-address" 
            @click="mainTowerAddressSheet = true"
        >
            <div class="main-tower-address-title">
                Адрес доставки
            </div>
            <div class="main-tower-address-description">
                <span>{{ getAddress(mainTowerAddress) }}</span>
            </div>
        </div>
        <div 
            v-else
            class="main-tower-address" 
        >
            <div class="main-tower-address-description">
                <nobr>Укажите адрес доставки</nobr>
            </div>
        </div>

        <!-- <div 
            v-else-if="skeleton === true"
            class="main-tower-address-skeleton" 
        >
            <div class="main-tower-address-title">
                &nbsp;
            </div>
            <div class="main-tower-address-description">
                <span><br><br></span>
            </div>
        </div> -->

        <Sheet
            v-model="mainTowerAddressSheet"
            :close-by-backdrop-click="false"
            :close-by-outside-click="false"
            :swipe-to-close="false"
            class="main-tower-address-sheet"
            disable-lines
        >
            <template slot="header">
                <div class="main-tower-address-sheet__title">
                    Адрес доставки
                </div>
                <div class="main-tower-address-sheet__close" @click="mainTowerAddressSheet = false"></div>
            </template>

            <template slot="body">
                <div class="address-sheet" :style="cssVars">
                    <f7-list-item
                        v-for="address in addressList"
                        :key="`address-${address.id}`"
                        swipeout
                        radio
                        :class="`checkbox-list__item checkbox-gradient-${ service }`"
                        name="address"
                        :checked="addressData.id === address.id"
                        @change="setAddress(address)"
                        @swipeout:deleted="deleteAddress(address)">
                        <div slot="inner" class="main-tower-address-sheet__address">
                            <div class="main-tower-address-sheet__address__title">
                                {{ getAddress(address) }}
                            </div>
                            <div class="main-tower-address-sheet__address__wrapper">
                                <template v-if="addressData.id === address.id && (!address.entrance || !address.floor || !address.appartment)">
                                    <div class="main-tower-address-sheet__address__row">
                                        <div class="main-tower-address-sheet__address__col">
                                            <div class="main-tower-address-sheet__input input" :class="{'input-label__show': addressData.entrance, 'input-with-errors': errorFields.indexOf('entrance') >= 0}">
                                                <input
                                                    type="text"
                                                    required
                                                    validate
                                                    :value="addressData.entrance"
                                                    @input="addressData.entrance = $event.target.value" />
                                                <div class="input-label">Под/корп</div>
                                            </div>
                                        </div>
                                        <div class="main-tower-address-sheet__address__col">
                                            <div class="main-tower-address-sheet__input input" :class="{'input-label__show': addressData.floor}">
                                                <input
                                                    type="text"
                                                    inputmode="numeric"
                                                    pattern="[0-9]*"
                                                    required
                                                    validate
                                                    :value="addressData.floor"
                                                    @input="onFloorInput"
                                                    @keypress="onFloorKeypress" />
                                                <div class="input-label">Этаж</div>
                                            </div>
                                        </div>
                                        <div class="main-tower-address-sheet__address__col">
                                            <div class="main-tower-address-sheet__input input" :class="{'input-label__show': addressData.appartment, 'input-with-errors': errorFields.indexOf('appartment') >= 0}">
                                                <input
                                                    type="text"
                                                    required
                                                    validate
                                                    :value="addressData.appartment"
                                                    @input="addressData.appartment = $event.target.value" />
                                                <div class="input-label">Кв/офис</div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- <div class="main-tower-address-sheet__address__description">
                                        Зона доставки ограничена территорией делового центра «Москва-Сити» и ЖК «Сити Парк»
                                    </div> -->
                                </template>
                            </div>
                        </div>
                        <f7-swipeout-actions v-if="addressList.length > 1" right>
                            <f7-swipeout-button delete confirm-text="Вы уверены, что хотите удалить адрес?">
                                <svg
                                    width="29"
                                    height="28"
                                    viewBox="0 0 29 28"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.4658 22.7686H18.543C19.8965 22.7686 20.7666 21.9512 20.8369 20.5977L21.4258 7.94141H22.3926C22.8408 7.94141 23.1836 7.58984 23.1836 7.15039C23.1836 6.71094 22.832 6.37695 22.3926 6.37695H18.4902V5.05859C18.4902 3.70508 17.6289 2.91406 16.1611 2.91406H12.8213C11.3535 2.91406 10.4922 3.70508 10.4922 5.05859V6.37695H6.60742C6.16797 6.37695 5.81641 6.71973 5.81641 7.15039C5.81641 7.59863 6.16797 7.94141 6.60742 7.94141H7.57422L8.16309 20.5977C8.2334 21.96 9.09473 22.7686 10.4658 22.7686ZM12.1357 5.1377C12.1357 4.68945 12.4521 4.39941 12.9355 4.39941H16.0469C16.5303 4.39941 16.8467 4.68945 16.8467 5.1377V6.37695H12.1357V5.1377ZM10.6416 21.1953C10.1582 21.1953 9.80664 20.835 9.78027 20.3164L9.19141 7.94141H19.7822L19.2109 20.3164C19.1934 20.8438 18.8506 21.1953 18.3496 21.1953H10.6416ZM11.9072 19.7803C12.2852 19.7803 12.5225 19.543 12.5137 19.1914L12.25 9.99805C12.2412 9.64648 11.9951 9.41797 11.6348 9.41797C11.2656 9.41797 11.0283 9.65527 11.0371 10.0068L11.3008 19.2002C11.3096 19.5518 11.5557 19.7803 11.9072 19.7803ZM14.5 19.7803C14.8691 19.7803 15.124 19.5518 15.124 19.2002V10.0068C15.124 9.65527 14.8691 9.41797 14.5 9.41797C14.1309 9.41797 13.8848 9.65527 13.8848 10.0068V19.2002C13.8848 19.5518 14.1309 19.7803 14.5 19.7803ZM17.0928 19.7891C17.4443 19.7891 17.6904 19.5518 17.6992 19.2002L17.9629 10.0068C17.9717 9.65527 17.7344 9.42676 17.3652 9.42676C17.0049 9.42676 16.7588 9.65527 16.75 10.0068L16.4863 19.2002C16.4775 19.543 16.7148 19.7891 17.0928 19.7891Z" fill="white" />
                                </svg>
                            </f7-swipeout-button>
                        </f7-swipeout-actions>
                    </f7-list-item>

                    <!-- Новый адрес -->
                    <f7-list-item
                        v-if="addressList.length"
                        radio
                        :class="`checkbox-list__item checkbox-list__item__new checkbox-gradient-${ service }`"
                        name="address"
                        :checked="!addressData.id"
                        @change="newAddress()">
                        <div class="main-tower-address-sheet__address">
                            <div class="main-tower-address-sheet__address__title">Новый адрес</div>
                        </div>
                    </f7-list-item>
                    <div class="main-tower-address-sheet__address__new" v-if="!addressData.id">
                        <f7-row>
                            <f7-col width="100">
                                <f7-list class="main-tower-address-sheet__smart-select" :class="{'select-with-errors': errorFields.indexOf('tower') >= 0}">
                                    <f7-list-item
                                        name="tower-select"
                                        :class="addressData.tower.id ? '' : 'main-tower-address-sheet__smart-select__placeholder'"
                                        :title="addressData.tower.name"
                                        smart-select
                                        :smart-select-params="{
                                            openIn: 'sheet', 
                                            cssClass: 'main-tower-address-sheet__smart-select__sheet', 
                                            sheetSwipeToClose: true, routableModals: 
                                            false, closeOnSelect: true, 
                                            sheetCloseLinkText: 'Отмена'
                                        }">
                                        <select @change="setTower($event.target.value)">
                                            <template v-for="(tower, index) in towersList">
                                                <option
                                                    :key="index"
                                                    :value="index"
                                                    :selected="addressData.tower.id === tower.id">{{ tower.name }}</option>
                                            </template>
                                        </select>
                                    </f7-list-item>
                                </f7-list>
                            </f7-col>
                        </f7-row>
                        <f7-row v-if="addressData.tower.id === -1">
                            <f7-col width="66">
                                <div class="main-tower-address-sheet__input input" :class="{'input-label__show': addressData.street, 'input-with-errors': errorFields.indexOf('street') >= 0}">
                                    <input
                                        type="text"
                                        required
                                        validate
                                        :value="addressData.street"
                                        @input="addressData.street = $event.target.value" />
                                    <div class="input-label">Улица</div>
                                </div>
                            </f7-col>
                            <f7-col width="33">
                                <div class="main-tower-address-sheet__input input" :class="{'input-label__show': addressData.building, 'input-with-errors': errorFields.indexOf('building') >= 0}">
                                    <input
                                        type="text"
                                        required
                                        validate
                                        :value="addressData.building"
                                        @input="addressData.building = $event.target.value" />
                                    <div class="input-label">Дом</div>
                                </div>
                            </f7-col>
                        </f7-row>

                        <f7-row>
                            <f7-col width="33">
                                <div class="main-tower-address-sheet__input input" :class="{'input-label__show': addressData.entrance, 'input-with-errors': errorFields.indexOf('entrance') >= 0}">
                                    <input
                                        type="text"
                                        required
                                        validate
                                        :value="addressData.entrance"
                                        @input="addressData.entrance = $event.target.value" />
                                    <div class="input-label">Под/корп</div>
                                </div>
                            </f7-col>
                            <f7-col width="33">
                                <div class="main-tower-address-sheet__input input" :class="{'input-label__show': addressData.floor}">
                                    <input
                                        type="text"
                                        inputmode="numeric"
                                        pattern="[0-9]*"
                                        required
                                        validate
                                        :value="addressData.floor"
                                        @input="onFloorInput"
                                        @keypress="onFloorKeypress" />
                                    <div class="input-label">Этаж</div>
                                </div>
                            </f7-col>
                            <f7-col width="33">
                                <div class="main-tower-address-sheet__input input" :class="{'input-label__show': addressData.appartment, 'input-with-errors': errorFields.indexOf('appartment') >= 0}">
                                    <input
                                        type="text"
                                        required
                                        validate
                                        :value="addressData.appartment"
                                        @input="addressData.appartment = $event.target.value" />
                                    <div class="input-label">Кв/офис</div>
                                </div>
                            </f7-col>
                        </f7-row>

                        <!-- <div class="main-tower-address-sheet__address__description">
                            Зона доставки ограничена территорией делового центра «Москва-Сити» и ЖК «Сити Парк»
                        </div> -->
                    </div>
                    <!-- Новый адрес -->
                </div>
            </template>

            <template slot="footer">
                <div class="main-tower-address-sheet__button">
                    <button
                        class="custom-button"
                        @click="saveAddress()"
                    >
                        Сохранить
                    </button>
                </div>
            </template>
        </Sheet>

        <Sheet
            v-model="mainTowerAddressSheetTowers"
            class="main-tower-address-sheet main-tower-main-tower-address-sheet__tower-sheet"
            :close-by-backdrop-click="false"
            :close-by-outside-click="false"
            :swipe-to-close="false"
            disable-lines
        >
            <template slot="header">
                <div class="main-tower-main-tower-address-sheet__title">
                    Выберите башню
                </div>
                <!-- <div class="main-tower-main-tower-address-sheet__close" @click="mainTowerAddressSheetTowers = false"></div> -->
            </template>

            <template slot="body">
                <f7-list class="main-tower-main-tower-address-sheet__smart-select main-tower-main-tower-address-sheet__tower-list">
                    <template v-for="(tower, index) in towers">
                        <f7-list-item
                            v-if="index > 0"
                            :key="index"
                            @click="setMainAddressTower(tower)">
                            {{ tower.name }}
                        </f7-list-item>
                    </template>
                </f7-list>
            </template>
        </Sheet>
    </div>
</template>

<script>
    import { f7 } from 'framework7-vue';
    import store from '@/store';
    import { mapState } from 'vuex';
    import Sheet from '@/components/Sheet';

    export default {
        name: 'MainTowerAddress',

        components: {
            Sheet
        },

        props: {
            service: {
                type: String,
                default: ''
            },
            entityCode: {
                type: String,
                default: ''
            },
            skeleton: {
                type: Boolean,
                default: false,
            },
            homePage: {
                type: Boolean,
                default: false,
            },
        },

        data: () => ({
            mainTowerAddress: null,
            mainTowerAddressSheet: false,
            mainTowerAddressSheetTowers: false,
            addressData: {
                id: null,
                tower: {
                    id: null,
                    name: 'Выберите башню Москва Сити',
                    pictures: [],
                },
                street: '',
                building: '',
                entrance: '',
                floor: '',
                appartment: '',
            },
            errorFields: [],
        }),

        computed: {
            ...mapState('remoteConfig', ['defaultValue', 'config']),
            ...mapState('auth', {
                user: state => state.user
            }),
            ...mapState('info', {
                towers: state => state.towers
            }),
            ...mapState('addresses', {
                addresses: state => state.list
            }),
            ...mapState('style', ['colors', 'backgrounds']),
            cssVars() {
                if (this.entityCode) {
                    return {
                        '--entity-bg-color': this.backgrounds[this.entityCode] || '',
                        '--entity-color': this.backgrounds[this.entityCode] || ''
                    };
                }
                return {};
            },
            towersList() {
                let towers = [];
                if(this.towers) {
                    towers = [
                        { id: null, name: 'Выберите башню Москва Сити' },
                        ...this.towers,
                        { id: -1, name: 'Другой адрес' }
                    ];
                }

                return towers;
            },
            addressList() {
                const addressList = this.addresses.map(item => {
                    return {
                        ...item,
                        tower: this.towers.find(tower => {
                            return tower.id === item.tower_id
                        })
                    }
                });
                return addressList;
            },
        },

        async mounted() {
            if(this.config.TOWER_ADDRESS_POPUP) {
                await store.dispatch('auth/getProfile', { onlyCheck: true });
                await store.dispatch('info/getTowers');
                if(this.user && this.user.id) {
                    await this.updateMainAddress();
                } else {
                    this.$emit('set-tower', null);
                }
            } else {
                this.$emit('set-tower', null);
            }

            if (this.user && this.user.id && !this.mainTowerAddress?.id && this.mainTowerAddressSheetTowers === false) {
                this.mainTowerAddressSheetTowers = true;
            }
        },
        
        methods: {
            getAddress(adress) {
                if (adress) {
                    if (adress.tower_id) {
                        return `${adress.tower.name}${adress.entrance ? `, под/корп ${adress.entrance}` : ''}${adress.floor ? `, этаж ${adress.floor}` : ''}${adress.appartment ? `, кв/офис ${adress.appartment}` : ''}`;
                    } else {
                        return `${adress.street}, дом ${adress.building}${adress.entrance ? `, под/корп ${adress.entrance}` : ''}${adress.floor ? `, этаж ${adress.floor}` : ''}${adress.appartment ? `, кв/офис ${adress.appartment}` : ''}`;
                    }
                }
                return '';
            },
            newAddress() {
                this.addressData = {
                    id: null,
                    tower: {
                        id: null,
                        name: 'Выберите башню Москва Сити',
                        pictures: [],
                    },
                    street: '',
                    building: '',
                    entrance: '',
                    floor: '',
                    appartment: ''
                };
            },
            setAddress(address) {
                this.addressData = {
                    ...address,
                    ...{
                        tower: address.tower_id ? 
                            this.towers.find(item => item.id === address.tower_id) :  
                            address.street ? { id: -1, name: 'Другой адрес' } : { id: null, name: 'Выберите башню Москва Сити', pictures: [] }
                    }
                }
            },
            setTower(index) {
                this.addressData.tower = this.towersList[index];
            },
            onFloorKeypress(event) {
                // Разрешаем только цифры (коды 48-57)
                const charCode = event.which ? event.which : event.keyCode;
                if (charCode < 48 || charCode > 57) {
                    event.preventDefault();
                }
            },
            onFloorInput(event) {
                let value = event.target.value.replace(/\D/g, '');
                if (value.length > 5) {
                    value = value.slice(0, 5);
                }
                this.addressData.floor = value;
            },
            async deleteAddress(address) {
                await store.dispatch('addresses/delete', { id: address.id });
                if (this.addressData.id === address.id) {
                    this.newAddress();
                }
                await this.updateMainAddress();
            },
            async updateMainAddress() {
                this.mainTowerAddress = null;
                await store.dispatch('auth/getProfile', {});
                await store.dispatch('addresses/fetch');
                if(this.user.addresses && this.user.addresses.length) {
                    this.mainTowerAddress = this.user.addresses.find(item => item.main);
                }
                if(this.mainTowerAddress) {
                    this.setAddress(this.mainTowerAddress);
                    if(this.config.TOWER_ENTITIES_SORT){
                        this.$emit('set-tower', this.mainTowerAddress.tower_id);
                    } else {
                        this.$emit('set-tower', null);
                    }
                } else {
                    if(this.addressList.length) {
                        this.setAddress(this.addressList[0]);
                    }
                    if (!this.mainTowerAddressSheetTowers) {
                        this.mainTowerAddressSheetTowers = true;
                    }
                }
            },
            async saveAddress() {
                this.errorFields = []; 
                const errorMessage = [];
                const address = this.addressData;
                if (address.tower.id === null) {
                    this.errorFields.push('tower');
                    errorMessage.push('Не выбрана башня');
                }
                if (address.tower.id === -1) {
                    if (!address.street) {
                        this.errorFields.push('street');
                        errorMessage.push('Не указана улица');
                    }
                    if (!address.building) {
                        this.errorFields.push('building');
                        errorMessage.push('Не указан дом');
                    }
                }

                // if (!address.entrance) {
                //     this.errorFields.push('entrance');
                //     errorMessage.push('Не указан под/корп');
                // }
                // if (!address.floor) {
                //     this.errorFields.push('floor');
                //     errorMessage.push('Не указан этаж');
                // }
                // if (!address.appartment) {
                //     this.errorFields.push('appartment');
                //     errorMessage.push('Не указаны квартира/офис');
                // }

                if (this.errorFields.length) {
                    this.$f7.dialog.alert(errorMessage.join('<br>'));
                    return;
                }
                
                await store.dispatch('addresses/create', {
                    address: {
                        ...this.addressData,
                        tower_id: this.addressData.tower.id,
                        main: true
                    }
                });
                this.mainTowerAddressSheet = false;
                this.mainTowerAddressSheetTowers = false;

                await this.updateMainAddress();
            },
            setMainAddressTower(tower) {
                this.addressData.tower = tower;
                this.saveAddress();
            }
        },
    };
</script>

<style lang="scss">
.tower-address-wrapper {
    background-color: #F6F6F6;
    border-radius: 10px;
    margin-bottom: 16px;
}

.main-tower-address {
    display: flex;
    padding: 10px 60px 10px 16px;
    font-weight: 400;
    font-size: 15px;
    line-height: 130%;
    color: #000000;
    position: relative;
    flex-direction: column;

    &::after {
        content: '';
        position: absolute;
        top: 50%;
        right: 16px;
        width: 7px;
        height: 12px;
        background: url("../../static/arrow-right-black.svg") no-repeat 50%/cover;
        transform: translateY(-50%);
    }


    &-title {     
        font-size: 11px;
        line-height: 12px;
        color: #919191;
        margin-bottom: 5px;
        width: 80%;
    }

    &-description {
        font-size: 13px;
        line-height: 16px;
        color: #000000;
        width: 80%;
    }

    &-skeleton {
        display: flex;
        padding: 10px 60px 10px 16px;
        font-weight: 400;
        font-size: 15px;
        line-height: 130%;
        color: #000000;
        position: relative;
        flex-direction: column;
    }
}

.tower-address-wrapper.home-tower-address {
    background: none;
    margin: 0;

    .main-tower-address {
        padding: 0 0 0 8px;

        &::after {
            display: none;
        }
    }

    .main-tower-address-title {
        display: none;
    }
    .main-tower-address-description {
        position: relative;
        width: auto;
        max-width: calc(100vw - 170px);

        &::after {
            content: '';
            position: absolute;
            top: 0;
            right: -28px;
            width: 20px;
            height: 20px;
            background: url("../../static/home/arrow-right-black.svg") no-repeat 50%/cover;
        }
    }
}

.main-tower-address-sheet {
    max-height: 90vh;
    padding: 0;
    overflow: hidden;

    .sheet-modal-inner {
        padding: 22px 18px 35px !important;
        padding-bottom: calc(constant(safe-area-inset-bottom) + 35px) !important;
        padding-bottom: calc(env(safe-area-inset-bottom) + 35px) !important;
    }
    .base-sheet-popup__body {
        max-height: calc(90vh - 170px);
        overflow-y: auto;
    }

    &__tower-list {
        overflow-y: auto;
        max-height: calc(90vh - 90px);
        margin-top: 20px;
    }

    &__title {
        font-size: 18px;
        font-weight: 700;
        line-height: 20px;
        color: #232321;
        margin-bottom: 30px;
    }

    &__close {
        position: absolute;
        top: 14px;
        right: 16px;
        width: 32px;
        height: 32px;
        background-color: rgba(255, 255, 255, 0.24);
        border-radius: 50%;
        cursor: pointer;
        background-image: url('../../static/close-onboarding.svg');
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        z-index: 100001;
    }


    &__input {
        padding: 12px 13px;
        margin-bottom: 0;
    }

    &__button {
        margin-top: 14px;
    }

    .item-content.active-state {
        background: transparent;
    }
    .item-inner {
        width: 100%;
        padding: 0 !important;
    }
    .checkbox-list__item .item-content {
        align-items: flex-start;
    }
    .input > input, .input > textarea {
        font-size: 14px;
        line-height: 14px;
    }
    .input > .input-label {
        top: 11px;
        left: 13px;
    }
    .input.input-label__show > .input-label {
        top: 0;
        left: 6px
    }
    .checkbox-list__item__new {
        margin-top: 14px;

        & label.item-radio input[type="radio"] ~ .icon-radio, 
        & label.item-radio:not(.item-radio-icon-start) input[type="radio"] ~ .icon-radio {
            background: url('../../static/address-select-plus.svg') center center no-repeat !important;
            border: none;
        }
        & label.item-radio input[type="radio"]:checked ~ .icon-radio, 
        & label.item-radio:not(.item-radio-icon-start) input[type="radio"]:checked ~ .icon-radio {
            background: url('../../static/address-select-minus.svg') center center no-repeat !important;
            border: none;
        }
        & label.item-radio input[type="radio"]:checked ~ .icon-radio:after {
            display: none;
        }
    }

    &__address {
        width: 100%;
        // display: flex;
        // justify-content: space-between;
        // align-items: center;
        padding: 0 0 16px 0;

        &__wrapper {
            margin-left: -32px;
        }
        &__new {
            margin-bottom: 16px;
        }
        &__title {
            font-size: 16px;
            font-weight: 400;
            line-height: 22px;
        }
        &__row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 20px;
        }
        &__col {
            width: calc(33% - 5px);
        }
        &__description {
            font-size: 12px;
            font-weight: 400;
            line-height: 16px;
            background: #FFF0ED;
            border-radius: 6px;
            padding: 14px;
            margin-top: 20px;
        }
        &__delete {
            background: #e3001a;
        }
    }

    .gradient-pink-blue {
        background: linear-gradient(
            86.28deg,
            #eee1fb 0%,
            #fde1e4 34.9%,
            #d8e8f9 67.19%,
            #d2f4f4 100%
        );
    }

    ul,
    li {
        list-style-type: none;
    }

    &__list {
        margin: 0;
        margin-bottom: 16px;

        ul:before,
        ul:after {
            display: none;
        }

        .item-title > div {
            display: flex;
            flex-direction: row;
            white-space: nowrap;

            > img {
                margin-left: 5px;
            }
        }
    }

    &__smart-select {
        margin: 0;
        &.list ul:before,
        &.list ul:after {
            display: none;
        }
        &.list .item-link {
            background: #ffffff;
            border: 1px solid #bdbdbd;
            border-radius: 6px;
            margin-bottom: 20px;
            padding: 0 0 0 13px;
        }
        &.list.select-with-errors .item-link {
            border: 1px solid #ff3b30;
        }
        &.list .item-inner {
            padding-top: 0;
            padding-bottom: 0;

            font-weight: 300;
            font-size: 14px;
        }
        &.list .item-content {
            padding: 0;
        }
        &.list .item-after {
            display: none;
            padding: 0;
            margin: 0;
        }

        &__placeholder {
            .item-title {
                color: #a0aec0;
            }
        }

        &__sheet {
            height: 600px;

            ul > li:first-child {
                display: none;
            }
            .toolbar-top {
                display: none !important;
            }
            .sheet-modal-inner {
                height: 100% !important;
            }
        }
    }
}
.field-error-message {
    color: #ff3b30;
    font-size: 12px;
    margin-top: 4px;
}
</style>
